import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import selectObject from '../../lib/utils/selectObject';

type QueryParamsType = Record<string, string | number | null>;
type UseQueryParamStateReturnType<T extends QueryParamsType> = [T, (values: Partial<T>) => void];

const useQueryParamState = <T extends QueryParamsType>(initialValue: T): UseQueryParamStateReturnType<T> => {
  const navigate = useNavigate();
  const location = useLocation();
  const { search, pathname } = location;
  const searchParams = queryString.parse(search, {
    parseNumbers: true,
  });

  const queryParams = initialValue
    ? selectObject({ ...initialValue, ...searchParams }, Object.keys(initialValue))
    : searchParams;
  const setQueryParams = (values: Partial<T>) => {
    const newParam = { ...queryParams, ...values };
    const newSearch = queryString.stringify(
      { ...searchParams, ...newParam },
      {
        skipNull: true,
        skipEmptyString: true,
      },
    );
    navigate({
      pathname,
      search: newSearch,
    });
  };

  return [queryParams as T, setQueryParams];
};

export default useQueryParamState;
